import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { useOrganization } from "./useOrganization";
import clientsService from "@/services/clients/clients";

export const useClientsPage = (page: number, search: string) => {
  const { currentOrganization } = useOrganization();
  const orgId = currentOrganization?.id ?? "";
  const searchKey = search ?? "";

  const { data, isPending: isLoading, isFetching, error } = useQuery({
    queryKey: ["clients", orgId, page, searchKey],
    queryFn: () =>
      clientsService.getClientsPage(orgId, {
        page,
        search: searchKey,
        pageSize: 20,
      }),
    enabled: !!currentOrganization?.id,
    placeholderData: keepPreviousData,
  });

  return {
    clients: data?.clients ?? [],
    total: data?.total ?? 0,
    isLoading,
    isFetching,
    error,
  };
};
